import React from 'react';
import PropTypes from 'prop-types';

import '/components/map/styles/map-cluster.scss';

const MapCluster = ({ count, onClick }) => (
    <button className="map-cluster" onClick={onClick}>
        {count}
    </button>
);

MapCluster.propTypes = {
    count: PropTypes.number.isRequired,
    onClick: PropTypes.func.isRequired,
};

export { MapCluster };
